import React from "react";
import { NumberInputField } from "@smartsuite/react-ui/lib/components/forms/NumberInputField/NumberInputField";
import { Text } from "@smartsuite/react-ui/lib/components/typography/Text/Text";

import { PaddingDirections } from "../../PageDesigner/PageDesigner";

export interface updateValues {
  direction: string;
  value: number;
}

export interface DirectionsInputsProps {
  title: string;
  values: PaddingDirections;
  updateValues: ({ direction, value }: updateValues) => void;
}

export const DirectionsInputs: React.FC<DirectionsInputsProps> = ({
  title,
  values,
  updateValues,
}) => {
  return (
    <div className="input-directions">
      <Text weight="medium" className="input-directions__title">
        {title}
      </Text>

      <div className="input-directions__in">
        <div className="input-directions__border-background"></div>
        <div className="input-directions__extremity">
          <div className="slot">
            <NumberInputField
              value={`${values.top}`}
              autoHideNavigation={true}
              showSymbol={false}
              min="0"
              onChangeValue={(value: string) =>
                updateValues({
                  direction: "top",
                  value: value ? parseInt(value) : 0,
                })
              }
            />
          </div>
        </div>
        <div className="input-directions__middle">
          <div className="slot">
            <NumberInputField
              value={`${values.left}`}
              autoHideNavigation={true}
              showSymbol={false}
              min="0"
              onChangeValue={(value: string) =>
                updateValues({
                  direction: "left",
                  value: value ? parseInt(value) : 0,
                })
              }
            />
          </div>
          <div className="slot">
            <NumberInputField
              value={`${values.right}`}
              autoHideNavigation={true}
              showSymbol={false}
              min="0"
              onChangeValue={(value: string) =>
                updateValues({
                  direction: "right",
                  value: value ? parseInt(value) : 0,
                })
              }
            />
          </div>
        </div>
        <div className="input-directions__extremity">
          <div className="slot">
            <NumberInputField
              value={`${values.bottom}`}
              autoHideNavigation={true}
              showSymbol={false}
              min="0"
              onChangeValue={(value: string) =>
                updateValues({
                  direction: "bottom",
                  value: value ? parseInt(value) : 0,
                })
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};
